export default __webpack_public_path__ + "static/media/logo-lg-1920w.2e37b303.webp";